import React, { useState } from 'react';
import { format, addMonths, subMonths, getMonth, getYear, setMonth } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faSync } from '@fortawesome/free-solid-svg-icons';
import './TimeNavigationBar.css';

const TimeNavigationBar = ({ onDateChange, initialDate = new Date(), onRefresh, isRefreshing = false }) => {
  const [currentDate, setCurrentDate] = useState(initialDate);

  // Get current quarter from date (0-based: 0, 1, 2, 3)
  const getQuarter = (date) => {
    const month = getMonth(date);
    return Math.floor(month / 3);
  };

  // Get first month of quarter (0-based: 0, 3, 6, 9)
  const getQuarterStartMonth = (quarter) => {
    return quarter * 3;
  };

  // Format quarter display text
  const formatQuarter = (date) => {
    const quarter = getQuarter(date);
    const year = getYear(date);
    
    const quarterLabels = [
      'Jan - Mar',
      'Apr - Jun',
      'Jul - Sep',
      'Oct - Dec'
    ];
    
    return `${quarterLabels[quarter]} ${year}`;
  };

  const handlePreviousQuarter = () => {
    const currentQuarter = getQuarter(currentDate);
    // Go back 3 months to move to previous quarter
    const newDate = subMonths(currentDate, 3);
    
    // Ensure we're at the first month of the quarter
    const newQuarterStart = setMonth(newDate, getQuarterStartMonth(getQuarter(newDate)));
    
    setCurrentDate(newQuarterStart);
    onDateChange(newQuarterStart);
  };

  const handleNextQuarter = () => {
    const currentQuarter = getQuarter(currentDate);
    // Go forward 3 months to move to next quarter
    const newDate = addMonths(currentDate, 3);
    
    // Ensure we're at the first month of the quarter
    const newQuarterStart = setMonth(newDate, getQuarterStartMonth(getQuarter(newDate)));
    
    setCurrentDate(newQuarterStart);
    onDateChange(newQuarterStart);
  };

  const handleJumpToToday = () => {
    const today = new Date();
    // Set to the first month of the current quarter
    const currentQuarter = getQuarter(today);
    const currentQuarterStart = setMonth(today, getQuarterStartMonth(currentQuarter));
    
    setCurrentDate(currentQuarterStart);
    onDateChange(currentQuarterStart);
  };

  return (
    <div className="time-navigation-bar">
      <div className="time-navigation-controls">
        <button 
          className={`nav-button refresh-nav-button ${isRefreshing ? 'refreshing' : ''}`}
          onClick={onRefresh}
          disabled={isRefreshing}
          aria-label="Refresh Data"
          title="Refresh current data"
        >
          <FontAwesomeIcon 
            icon={faSync} 
            className={isRefreshing ? 'spinning' : ''} 
          />
        </button>
        
        <button 
          className="nav-button"
          onClick={handlePreviousQuarter}
          aria-label="Previous Quarter"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        
        <div className="current-period">
          <span className="month-year">
            {formatQuarter(currentDate)}
          </span>
        </div>

        <button 
          className="nav-button"
          onClick={handleNextQuarter}
          aria-label="Next Quarter"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>

        <button 
          className="today-button"
          onClick={handleJumpToToday}
          aria-label="Jump to Current Quarter"
        >
          Current Quarter
        </button>
      </div>
    </div>
  );
};

export default TimeNavigationBar; 